module.exports = __webpack_public_path__ + "fonts/Ubuntu-BoldItalic.e28a337.ttf";